// 图表相关配置
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';

const lineColorMap = {
  'syl-point': '#E0AF74',
  'se-point': '#479DFF',
  'sameTypeAvg-point': '#FA5914',
  'sameTypeAvgCanBuy-point': '#FA5914',

  'mui-point': '#E0AF74',

  'type-point': '#999999',
  'bench-point': '#FF9900',
  'net-value-rate': '#479DFF',
  'history-net-value': '#FE6933',
};

export default {
  // 接口的点数据列表key，与图例展示顺序一致
  pointKeyList: {
    accProfit: [
      'sylPointList',
      'sePointList',
      'sameTypeAvgPointList',
      'sameTypeAvgCanBuyPointList',
    ],
    accProfit2: [
      'sylPointList',
      'sePointList',
      'sameTypeAvgPointList',
      'sameTypeAvgCanBuyPointList',
    ],
    perNetValue: ['navPointList', 'navRisePointList'],
    accNetValue: ['historyValueList'],
    trendOfGold: ['pointList', 'risePointList'],
    profitOf10000: ['netValueList', 'historyValueList'],
    annualizationOf7D: ['historyValueList', 'valueRateList'],
  },
  // 图例配置
  legendConfig: {
    // 累计收益
    accProfit: [
      {
        type: 'syl-point',
        iconType: 'dot', // dot | line
        color: '#E0AF74',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: 'periodText', // 标签名key, 为空时取label
        label: '近一年',
      },
      {
        type: 'sameTypeAvg-point',
        iconType: 'dot', // dot | line
        color: '#FA5914',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: '', // 标签名key, 为空时取label
        label: '同类平均',
        iconUrl: 'https://j5.dfcfw.com/WG/conf/20210419/d76b5662a99644b380dcfad42aa1763e.png',
        iconUrl2: 'https://img.1234567.com.cn/trade/2018102616580210.png',
      },
      {
        type: 'se-point',
        iconType: 'dot', // dot | line
        color: '#479DFF',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: 'indexName', // 标签名key, 为空时取label
        label: '沪深300',
      },
    ],
    accProfit2: [
      {
        type: 'syl-point',
        iconType: 'dot', // dot | line
        color: '#E0AF74',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: 'periodText', // 标签名key, 为空时取label
        label: '近一年',
      },
      {
        type: 'sameTypeAvgCanBuy-point',
        iconType: 'dot', // dot | line
        color: '#FA5914',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: '', // 标签名key, 为空时取label
        label: '在售同类平均',
        iconUrl: 'https://j5.dfcfw.com/WG/conf/20210419/d76b5662a99644b380dcfad42aa1763e.png',
        iconUrl2: 'https://img.1234567.com.cn/trade/2018102616580210.png',
      },
      {
        type: 'se-point',
        iconType: 'dot', // dot | line
        color: '#479DFF',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: 'indexName', // 标签名key, 为空时取label
        label: '沪深300',
      },
    ],
    // 单位净值
    perNetValue: [
      {
        type: 'nav-point',
        iconType: '', // dot | line
        color: '#ff4400',
        isRateValue: false, // 是否需要涨红跌绿
        valueSymbol: '',
        labelKey: '', // 标签名key, 为空时取label
        label: '单位净值',
        valueFormatter: (value) => parseFloat(value)?.toFixed(4),
      },
      {
        type: 'navchgrt100-point',
        iconType: '', // dot | line
        color: '',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: '', // 标签名key, 为空时取label
        label: '日涨幅',
      },
    ],
    // 净值修复
    netFixed: [
      {
        type: 'history-net-value',
        iconType: 'dot', // dot | line
        color: '#ff4400',
        isRateValue: false, // 是否需要涨红跌绿
        valueSymbol: '',
        labelKey: '', // 标签名key, 为空时取label
        label: '累计净值',
        valueFormatter: (value) => parseFloat(value)?.toFixed(4),
      },
    ],
    // 货币基金-万元收益
    profitOf10000: [
      {
        type: 'per-net-value',
        iconType: '', // dot | line
        color: '#ff4400',
        isRateValue: false, // 是否需要涨红跌绿
        valueSymbol: '',
        labelKey: '', // 标签名key, 为空时取label
        label: '万元收益',
        valueFormatter: (value) => parseFloat(value)?.toFixed(4),
      },
      {
        type: 'history-net-value',
        iconType: '', // dot | line
        color: '',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: '', // 标签名key, 为空时取label
        label: '7日年化',
        valueFormatter: (value) => parseFloat(value)?.toFixed(4),
      },
    ],
    // 货币基金-7日年化
    annualizationOf7D: [
      {
        type: 'history-net-value',
        iconType: 'dot', // dot | line
        color: '#ff4400',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: '', // 标签名key, 为空时取label
        label: '7日年化',
        valueFormatter: (value) => parseFloat(value)?.toFixed(4),
      },
      {
        type: 'net-value-rate',
        iconType: 'dot', // dot | line
        color: '#008AFF',
        isRateValue: true, // 是否需要涨红跌绿
        valueSymbol: '%',
        labelKey: '', // 标签名key, 为空时取label
        label: '一年定存',
        valueFormatter: (value) => parseFloat(value)?.toFixed(2),
      },
    ],
  },
  lineChartConfig: {
    // 李冉新折线图配置
    accProfit: {
      // 累计收益
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => `${numeral(value).format('0.00')}%`,
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', (type) => (type === 'syl-point' ? 2 : 1)],
          color: ['type', (type) => lineColorMap[type] || '#ffffff'],
        },
        area: {
          color: [
            'type',
            (type) => (type === 'syl-point' ? 'l(90) 0:#E0AF74 1:#FEFFFF' : 'transparent'),
          ],
        },
      },
      tooltip: {
        main: ['type', 'syl-point'],
        crosshairsStyle: {
          // 辅助线样式
          stroke: '#E0AF74',
          lineDash: [4, 2],
        },
        tooltipMarkerStyle: {
          // 小圆点样式
          stroke: '#E0AF74',
          radius: 3,
          lineWidth: 2,
        },
        xTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
        yTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
      },
    },
    accProfit2: {
      // 累计收益
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => `${numeral(value).format('0.00')}%`,
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', (type) => (type === 'syl-point' ? 2 : 1)],
          color: ['type', (type) => lineColorMap[type] || '#ffffff'],
        },
        area: {
          color: [
            'type',
            (type) => (type === 'syl-point' ? 'l(90) 0:#E0AF74 1:#FEFFFF' : 'transparent'),
          ],
        },
      },
      tooltip: {
        main: ['type', 'syl-point'],
        crosshairsStyle: {
          // 辅助线样式
          stroke: '#E0AF74',
          lineDash: [4, 2],
        },
        tooltipMarkerStyle: {
          // 小圆点样式
          stroke: '#E0AF74',
          radius: 3,
          lineWidth: 2,
        },
        xTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
        yTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
      },
    },
    perNetValue: {
      // 单位净值
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => (isEmpty(value) ? '--' : value?.toFixed(4)), // 刻度格式化方法
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', [2]],
          color: ['type', ['#E0AF74']],
        },
        area: {
          color: ['type', ['l(90) 0:#E0AF74 1:#FEFFFF']],
        },
      },
      tooltip: {
        main: ['type', 'per-net-value'],
        crosshairsStyle: {
          // 辅助线样式
          stroke: '#E0AF74',
          lineDash: [4, 2],
        },
        tooltipMarkerStyle: {
          // 小圆点样式
          stroke: '#E0AF74',
          radius: 3,
          lineWidth: 2,
        },
        xTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
        yTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
      },
    },
    accNetValue: {
      // 累计净值
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => (isEmpty(value) ? '--' : value?.toFixed(4)), // 刻度格式化方法
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', [2]],
          color: ['type', ['#E0AF74']],
        },
        area: {
          color: ['type', ['l(90) 0:#E0AF74 1:#FEFFFF']],
        },
      },
      tooltip: {
        main: ['type', 'history-net-value'],
        crosshairsStyle: {
          // 辅助线样式
          stroke: '#E0AF74',
          lineDash: [4, 2],
        },
        tooltipMarkerStyle: {
          // 小圆点样式
          stroke: '#E0AF74',
          radius: 3,
          lineWidth: 2,
        },
        xTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
        yTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
      },
    },
    profitOf10000: {
      // 货币基金-万元收益
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => value?.toFixed(4), // 刻度格式化方法
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', [2]],
          color: ['type', ['#E0AF74']],
        },
        area: {
          color: ['type', ['l(90) 0:#E0AF74 1:#FEFFFF']],
        },
      },
      tooltip: {
        main: ['type', 'per-net-value'],
        crosshairsStyle: {
          // 辅助线样式
          stroke: '#E0AF74',
          lineDash: [4, 2],
        },
        tooltipMarkerStyle: {
          // 小圆点样式
          stroke: '#E0AF74',
          radius: 3,
          lineWidth: 2,
        },
        xTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
        yTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
      },
    },
    annualizationOf7D: {
      // 货币基金-7日年化
      xScale: {
        key: 'date',
        type: 'timeCat',
        tickCount: 2,
      },
      yScale: {
        key: 'value',
        type: 'linear',
        tickCount: 5,
        formatter: (value) => value?.toFixed(4), // 刻度格式化方法
      },
      yAxis: {
        key: 'value',
      },
      geometry: {
        line: {
          size: ['type', (type) => (type === 'history-net-value' ? 2 : 1)],
          color: ['type', (type) => lineColorMap[type] || '#ffffff'],
        },
        area: {
          color: [
            'type',
            (type) => (type === 'history-net-value' ? 'l(90) 0:#E0AF74 1:#FEFFFF' : 'transparent'),
          ],
        },
      },
      tooltip: {
        main: ['type', 'history-net-value'],
        crosshairsStyle: {
          // 辅助线样式
          stroke: '#E0AF74',
          lineDash: [4, 2],
        },
        tooltipMarkerStyle: {
          // 小圆点样式
          stroke: '#E0AF74',
          radius: 3,
          lineWidth: 2,
        },
        xTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
        yTipBackground: {
          // x轴辅助信息背景样式
          fill: '#E0AF74',
          radius: 2,
          padding: [2],
        },
      },
    },
  },
  // 图表配置
  chartConfig: {
    accProfit: {
      // 累计收益
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => `${numeral(value).format('0.00')}%`, // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'sameTypeAvg-point', // 同类平均
          size: 1,
          color: '#999999',
          shape: 'line',
        },
        {
          type: 'se-point', // 业绩比较基准
          size: 1,
          color: '#FF9900',
          shape: 'line',
        },
        {
          type: 'syl-point', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
          showMin: true,
          showMax: true,
          formatter: (value) => `${value.toFixed(2) || '--'}%`,
        },
      ],
      throttleTime: 200, // 节流时间
    },
    accProfit2: {
      // 累计收益
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => `${numeral(value).format('0.00')}%`, // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'sameTypeAvgCanBuy-point', // 同类平均
          size: 1,
          color: '#999999',
          shape: 'line',
        },
        {
          type: 'se-point', // 业绩比较基准
          size: 1,
          color: '#FF9900',
          shape: 'line',
        },
        {
          type: 'syl-point', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
          showMin: true,
          showMax: true,
          formatter: (value) => `${value.toFixed(2) || '--'}%`,
        },
      ],
      throttleTime: 200, // 节流时间
    },
    perNetValue: {
      // 单位净值
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => value?.toFixed(4), // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'nav-point', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
          showMax: true,
          showMin: true,
          formatter: (value) => `${value.toFixed(4) || '--'}%`,
        },
      ],
      throttleTime: 200, // 节流时间
    },
    netFixed: {
      // 净值修复
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => value?.toFixed(4), // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'history-net-value', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
        },
      ],
      throttleTime: 200, // 节流时间
    },
    profitOf10000: {
      // 货币基金-万元收益
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => value?.toFixed(4), // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'per-net-value', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
        },
      ],
      throttleTime: 200, // 节流时间
    },
    annualizationOf7D: {
      // 货币基金-7日年化
      // 横轴配置
      xAxisConfig: {
        key: 'date',
      },
      // 纵轴配置
      yAxisConfig: {
        key: 'value',
        scaleFormatter: (value) => value?.toFixed(4), // 刻度格式化方法
      },
      // 线条配置
      seriesConfig: [
        {
          type: 'history-net-value', // 基金累计收益
          size: 2,
          color: '#FE6933',
          shape: 'line',
          area: { color: 'l(90) 0:#FF7C4C 1:#FEFFFF' }, // 阴影
        },
      ],
      throttleTime: 200, // 节流时间
    },
  },
  // 指数弹窗默认配置
  indexPopupList: [
    { indexName: '上证指数', indexCode: '000001', color: '#000000' },
    { indexName: '深证指数', indexCode: '399001', color: '#000000' },
    { indexName: '创业板指', indexCode: '399006', color: '#000000' },
    { indexName: '沪深300', indexCode: '000300', color: '#000000' },
    { indexName: '中小100', indexCode: '399005', color: '#000000' },
    { indexName: '中证500', indexCode: '000905', color: '#000000' },
    { indexName: '上证50', indexCode: '000016', color: '#000000' },
    { indexName: '偏股基金指数', indexCode: '930950', color: '#000000' },
  ],
  chartFlagMap: new Map([
    [
      // 分红
      'dividend',
      {
        text: '分红',
        color: '#E48B17',
        flagColor: '#F59C26',
        lineColor: '#F59C26',
      },
    ],
    [
      // 基金经理变更
      'managerChange',
      {
        text: '经理变更',
        color: '#E48B17',
        flagColor: '#F59C26',
        lineColor: '#F59C26',
      },
    ],
    [
      // 巨额赎回
      'largeRedemption',
      {
        text: '巨额赎回',
        color: '#E48B17',
        flagColor: '#F59C26',
        lineColor: '#F59C26',
      },
    ],
  ]),
  chartPointMap: {
    dividend: '#F59C26',
    managerChange: '#F59C26',
    largeRedemption: '#F59C26',
  },
};
